import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { message } from 'antd';
import PlayLegal from './PlayLegal';
import GodLegal from './GodLegal';
import HTTP from '../../script/service';
import './index.scss';

const LegalRights = forwardRef(({ uid, changeOrder }, ref) => {
  const [type, setType] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [visible, setVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal: (order, type) => {
      if (order.orderId) {
        getOrderDetail(order.orderId, type);
      } else {
        console.error('订单异常： ', order, type);
      }
    },
  }));

  const getOrderDetail = (orderId, type) => {
    HTTP._get_order_detail({
      uid,
      orderId,
    }).then((res) => {
      if (res?.code === 200 && res.data) {
        if (type === 'god') {
          if (res.data?.appealStatus !== 2) {
            setOrderInfo(res.data);

            setType(type);

            setVisible(true);
          } else {
            message.warning('你已提交过维权申请，无需再次提交。');
          }
        } else {
          setOrderInfo(res.data);

          setType(type);

          setVisible(true);
        }
      } else {
        message.error(res?.message || '订单不存在');
      }
    });
  };

  const hideModal = () => {
    setVisible(false);
  };

  if (!orderInfo) return null;
  if (type === 'play') {
    // 用户维权
    return (
      <PlayLegal
        visible={visible}
        orderInfo={orderInfo}
        changeOrder={changeOrder}
        hideModal={hideModal}
      />
    );
  } else if (type === 'god') {
    // 大神维权
    return (
      <GodLegal
        visible={visible}
        orderInfo={orderInfo}
        changeOrder={changeOrder}
        hideModal={hideModal}
      />
    );
  }

  return null;
});

export default LegalRights;
